import axios from "axios";
import { TOGGLE_BAN_CONTACT, CONVERSATIONS_EMPLOYEE_BAN_UPDATE } from "./type";
import { CONTACTS_TYPE } from "constants/contacts";
import { CONTACTS } from "endpointsConst";

const URL = CONTACTS;

export function toggleBlockContact({ id, isBlock }) {
    return async (dispatch) => {
        try {
            let request = null;
            if (!isBlock) {
                request = axios.post(URL, {
                    id,
                    type: CONTACTS_TYPE.BLOCK,
                });
            } else {
                request = axios.patch(`${URL}/${id}`);
            }
            await request.then(() => {
                dispatch({ type: CONVERSATIONS_EMPLOYEE_BAN_UPDATE, payload: { id } });
                dispatch({ type: TOGGLE_BAN_CONTACT, payload: id });
            });
        } catch (error) {
            // TODO handle error
        }
    };
}
